import { useEffect, useState } from 'react'

import { contactService } from '../services'

const useContacts = (filter: string = '', status: number = 0, page: number = 1, limit: number = 5) => {
  const [data, setData] = useState<any[] | null>(null)

  useEffect(() => {
    getByFilter(filter, status, page, limit)
  }, [filter, status, page, limit])

  const getByFilter = async (filter: string = '', status: number = 0, page: number = 1, limit: number = 5) => {
    const resp: any = await contactService.getContacts(filter, status, page, limit)
    setData(resp.data)
  }

  return {
    data,
    getByFilter
  }
}

export { useContacts }